// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {uniqueId} from 'lodash';

// Actions
import * as overlayActions from '../actions/overlay-actions';

// Styles
import './overlay-trigger.scss';

class OverlayTrigger extends Component {
    state = {
        overlayId: uniqueId('overlay'),
    };

    triggerNode = null;

    getProps() {
        const {className, triggerType} = this.props;
        const props = {
            className: classnames('overlay-trigger', className),
            ref: triggerNode => (this.triggerNode = triggerNode),
        };

        if (triggerType === 'hover') {
            props.onMouseOver = this.openOverlay;
            props.onMouseOut = this.closeOverlay;
        } else {
            props.onClick = this.openOverlay;
        }

        return props;
    }

    openOverlay = () => {
        const {overlayId} = this.state;
        const {displayDirection, openOverlay, overlayRenderer} = this.props;

        openOverlay({
            displayDirection,
            id: overlayId,
            overlayRenderer,
            triggerNode: this.triggerNode,
        });
    };

    closeOverlay = () => {
        const {closeOverlay} = this.props;
        const {overlayId} = this.state;

        closeOverlay(overlayId);
    };

    render() {
        const {children} = this.props;

        return <div {...this.getProps()}>{children}</div>;
    }
}

OverlayTrigger.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    closeOverlay: PropTypes.func,
    displayDirection: PropTypes.string,
    openOverlay: PropTypes.func,
    overlayRenderer: PropTypes.func.isRequired,
    overlays: PropTypes.object.isRequired,
    triggerType: PropTypes.oneOf(['hover', 'click']),
};

OverlayTrigger.defaultProps = {
    triggerType: 'hover',
};

function mapStateToProps(state) {
    return {
        overlays: state.overlays,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({...overlayActions}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OverlayTrigger);
